// wsImport page
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, bindActionCreators } from 'redux';
import { connect, Provider } from 'react-redux';
import WsImportConst from './constants/wsImport.constants';
import WsImportReducers from './reducers/wsImport.reducers';
import * as WsImportActions from './actions/wsImport.actions';
import WorkStreamImport from './components/wsImport.component';


const mapsStateToPropsForWsImport = state => ({
  wsImport: state,
});

const mapsDispatchToPropsForWsImport = dispatch => ({
  actions: bindActionCreators(WsImportActions, dispatch),
});


const WsImportAppComp = connect(
  mapsStateToPropsForWsImport,
  mapsDispatchToPropsForWsImport,
)(WorkStreamImport);


const initWsImportComp = function (data) {
  const wsImportStore = createStore(WsImportReducers, data);
  ReactDOM.render(
    <Provider store={wsImportStore}>
      <WsImportAppComp />
    </Provider>,
    document.getElementById('wsImprotPage'),
  );
};


window.initWsImportComp = initWsImportComp;
